import { Label, Input, InputType } from '@gcl/react-core';
import * as React from 'react';
import { useDeepCompareEffectNoCheck } from 'use-deep-compare-effect';
import { NumberFilter, IFilterInputBaseProps } from '../searchFilter.models';
import { getFilterValue } from '../searchFilter.services';

export interface INumberFilterInputProps extends IFilterInputBaseProps<NumberFilter> {}

export const NumberFilterInput: React.FunctionComponent<INumberFilterInputProps> = ({
  fieldConfig,
  onChange,
  filter = {},
  disabled = false,
}) => {
  const [localValue, setLocalValue] = React.useState<number | undefined>(undefined);
  const { fieldName, displayName, disable } = fieldConfig;

  useDeepCompareEffectNoCheck(() => {
    const value = getFilterValue(fieldName, filter);

    setLocalValue(value && typeof value === 'number' ? value : undefined);
  }, [JSON.stringify(filter)]);

  return (
    <>
      <Label labelFor={fieldName}>{displayName}</Label>
      <Input
        id={`${fieldName}`}
        type={InputType.Number}
        disabled={disabled || disable}
        value={localValue}
        onChange={(newValue) => {
          onChange(fieldName, newValue ? Number(newValue) : undefined);
        }}
      />
    </>
  );
};
